import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
const BankService = {
  getAllBanks(obj) {
    return httpClient.post(endPoints.getAllBanks, obj);
  },
  getAllBanksByPagination(obj) {
    return httpClient.post(endPoints.getAllBanksByPagination, obj);
  },
  getBankDetailByBankCode(obj) {
    return httpClient.post(endPoints.getBankDetailByBankCode, obj);
  },
  addBank(obj) {
    return httpClient.post(endPoints.addBank, obj);
  },
  updateBank(obj) {
    return httpClient.post(endPoints.updateBank, obj);
  },
  deleteBank(obj) {
    return httpClient.post(endPoints.deleteBank, obj);
  },
};

export default BankService;



// WEBPACK FOOTER //
// ./src/service/BankService.js